import React, { Component, FormEvent } from 'react';
import { Container } from 'bloomer/lib/layout/Container';
import { Box } from 'bloomer/lib/elements/Box';
import moment from 'moment';
import MultiDatePicker from '../elements/MultiDatePicker';
import { Button } from 'bloomer/lib/elements/Button';
import api from '../util/api';
import { RouteComponentProps } from '@reach/router';
import CommentList from '../components/CommentList';
import Conditional from '../components/Conditional';
import { infoAlert, popupErrorFromServer } from '../util/helperFunctions';
import { Field } from 'bloomer/lib/elements/Form/Field/Field';
import { Control } from 'bloomer/lib/elements/Form/Control';
import { Label } from 'bloomer/lib/elements/Form/Label';
import { Section } from 'bloomer/lib/layout/Section';
import { Title } from 'bloomer/lib/elements/Title';

interface Params {
  aNumber: string;
}

interface PropTypes extends RouteComponentProps<Params> {
  path: string;
}
interface StateTypes {
  focusedInput: 'startDate' | 'endDate' | null;
  startDate: moment.Moment | null;
  endDate: moment.Moment | null;
  comments: Comment[];
  hasLoaded: boolean;
  isLoading: boolean;
}

class Comments extends Component<PropTypes, StateTypes> {
  state: StateTypes = {
    focusedInput: null,
    startDate: moment().startOf('day'),
    endDate: moment().endOf('day'),
    comments: [],
    hasLoaded: false,
    isLoading: false,
  };
  handleFocusChange = (focusedInput: StateTypes['focusedInput']) => this.setState({ focusedInput });

  handleDateChange = ({ startDate, endDate }: { startDate: moment.Moment | null; endDate: moment.Moment | null }) =>
    this.setState({ startDate, endDate, comments: [], hasLoaded: false });

  loadComments = async (e: FormEvent<HTMLFormElement>) => {
    try {
      e.preventDefault();
      this.setState({
        isLoading: true,
      });
      const { aNumber } = this.props;
      const { startDate, endDate } = this.state;
      if (!aNumber) return;
      if (!startDate || !endDate) {
        return infoAlert('Please select both a start and and end date');
      }
      const comments = await api.comments.get({
        aNumber,
        startDate: startDate.toISOString(),
        endDate: endDate.toISOString(),
      });

      this.setState({
        comments,
        hasLoaded: true,
        isLoading: false,
      });
    } catch (err) {
      popupErrorFromServer(err);
    }
  };

  render() {
    const { focusedInput, startDate, endDate, comments, hasLoaded, isLoading } = this.state;
    const { aNumber } = this.props;
    const startDateString = startDate ? startDate.format('dddd, MMMM DD YYYY') : 'start date';
    const endDateString = endDate ? endDate.format('dddd, MMMM DD YYYY') : 'end date';
    return (
      <Container>
        <Box>
          <Section>
            <Title tag="h2" isSize={4}>
              Comments for A#{aNumber}
            </Title>
            <form onSubmit={this.loadComments}>
              <Field>
                <Label>Please select a date range:</Label>
                <Control>
                  <MultiDatePicker
                    startDate={startDate}
                    endDate={endDate}
                    startDateId="comment-selection-date-start"
                    endDateId="comment-selection-date-start"
                    focusedInput={focusedInput}
                    onFocusChange={this.handleFocusChange}
                    onDatesChange={this.handleDateChange}
                  />
                </Control>
              </Field>
              <Field>
                <Control>
                  <Button isLoading={isLoading} type="submit" isColor="primary">
                    Load Comments
                  </Button>
                </Control>
              </Field>
            </form>
          </Section>
          <Conditional check={hasLoaded}>
            <Section>
              <Title tag="h2" isSize={4}>
                Found {comments.length} comments for A#{aNumber} between {startDateString} and {endDateString}
              </Title>
              <CommentList comments={comments} isLoading={isLoading} noMoreComments={true} />
            </Section>
          </Conditional>
        </Box>
      </Container>
    );
  }
}

export default Comments;
